import React, { useState, useEffect } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import {
  fetchSessionVideos,
  getSessionIntroOutroVideoUrls,
  // getSystemVideos,
} from '../../services/Interviews/chatbotService';
import InterviewHome from '../../components/AIChatbot/contents/InterviewHome';
import InterviewSession from '../../components/AIChatbot/contents/InterviewSession';
import SummaryPage from '../../components/AIChatbot/contents/SummaryPage';
import SmashLoader from '../../components/Loader/SmashLoader';
import Opening from '../../components/AIChatbot/contents/Opening';

export const AIChatbot = () => {
  const { session_id: sessionId } = useParams();
  const { setMenuHidden } = useOutletContext();
  const [view, setView] = useState('home');
  const [interviewData, setInterviewData] = useState(null);
  const [error, setError] = useState(null);
  const [sessionVideoUrls, setSessionVideoUrls] = useState(null);
  // const [systemVideos, setSystemVideos] = useState(null);
  window.setView = setView;

  useEffect(() => {
    if (sessionId) {
      setView('home');
      setInterviewData(null);
      setError(null);
    } else {
      setError('No session ID provided in the URL.');
      setView('error');
    }
  }, [sessionId]);

  useEffect(() => {
    setMenuHidden(view === 'session');
  }, [view, setMenuHidden]);

  useEffect(() => {
    return () => {
      setMenuHidden(false);
    };
  }, [setMenuHidden]);

  const handleStartInterviewAttempt = async () => {
    if (!sessionId) {
      setError('Session ID is missing.');
      setView('error');
      return;
    }

    setView('loading');
    setError(null);
    Promise.all([
      fetchSessionVideos({ params: { sessionId } }),
      getSessionIntroOutroVideoUrls({ params: { uuid: sessionId } }),
    ])
      .then(([sessionVideosResponse, sessionResponse]) => {
        if (sessionVideosResponse.length > 0) {
          setInterviewData(sessionVideosResponse);
          setView('opening');
          setSessionVideoUrls(sessionResponse);
        } else {
          setError('No questions found for this interview session.');
          setView('error');
          setSessionVideoUrls(null);
        }
      })
      .catch((err) => {
        console.error('Error starting interview:', err);
        setError('Failed to load interview questions. Please try again.');
        setView('error');
        setSessionVideoUrls(null);
      });
  };

  const handleStartQuestion = () => {
    setView('session');
  };

  const handleSessionComplete = () => {
    setView('summary');
  };

  const handleRestartInterview = () => {
    setView('home');
    setInterviewData(null);
    setError(null);
  };

  const renderContent = () => {
    switch (view) {
      case 'home':
        return (
          <InterviewHome
            sessionId={sessionId}
            onStartInterview={handleStartInterviewAttempt}
          />
        );
      case 'loading':
        return <SmashLoader />;
      case 'opening':
        return (
          <Opening
            videoSrc={sessionVideoUrls?.intro_video_url}
            // videoSrc={interviewData[0].video_file}
            handleStartQuestion={handleStartQuestion}
          />
        );
      case 'session':
        if (!interviewData) {
          setError('Interview data is missing or invalid.');
          setView('error');
          return null;
        }
        return (
          <InterviewSession
            data={interviewData}
            sessionId={sessionId}
            onSessionComplete={handleSessionComplete}
          />
        );
      case 'summary':
        return (
          <SummaryPage
            sessionId={sessionId}
            videoSrc={sessionVideoUrls?.outro_video_url}
            onRestart={handleRestartInterview}
          />
        );
      case 'error':
        return (
          <div className="text-center p-4">
            <h2 className="text-2xl font-semibold text-red-500 dark:text-red-400 mb-4">
              An Error Occurred
            </h2>
            <p className="mb-6 dark:text-gray-300">
              {error || 'Something went wrong.'}
            </p>
            <button
              onClick={handleRestartInterview}
              className="bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700"
            >
              Try Again
            </button>
          </div>
        );
      default:
        return <p className="text-center dark:text-gray-300">Unknown state.</p>;
    }
  };

  return (
    <div className="max-h-main h-full flex flex-col items-center justify-start bg-gray-100 dark:bg-gray-900 overflow-auto">
      {renderContent()}
    </div>
  );
};

export default AIChatbot;
